import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AltRouteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"alt_route"}/>
}
